import { useState } from 'react';
import { useTerminals } from '@/hooks/useHubData';
import { LoadError } from '@/components/feature/DataSource';
import DeviceList from './components/DeviceList';
import RegisterDeviceModal from './components/RegisterDeviceModal';

export default function DevicesPage() {
  const [showRegister, setShowRegister] = useState(false);
  const { terminals, loaded, error, refetch } = useTerminals();

  // ★ 只有**首屏还没数据**才整页转圈。以前这里写的是 `if (loading)`, 而 refetch
  //   也会把 loading 拉回 true —— 于是每刷新一次列表, 整棵 DeviceList 子树连同
  //   详情抽屉一起卸载重建。2026-09-11 现场: 点「轮换令牌 → 确认」后抽屉整个消失,
  //   一次性明文令牌随组件状态一起没了, 而服务端旧令牌已经作废 —— 点几次烧几把,
  //   一把都拿不到。详见 useHubData.ts 里 Source.loaded 那段。
  if (!loaded) return (
    <div className="p-6 flex items-center justify-center min-h-[60vh]">
      <div className="flex flex-col items-center gap-3">
        <i className="ri-loader-4-line text-2xl text-accent-500 animate-spin" />
        <p className="text-xs text-foreground-400">正在读取设备注册表...</p>
      </div>
    </div>
  );

  return (
    <div className="p-4 lg:p-6">
      <div className="mb-4 lg:mb-5 animate-fade-in-up">
        <h1 className="text-lg font-bold text-foreground-900 font-heading">设备管理</h1>
        <p className="text-xs text-foreground-500 mt-1">设备注册表(每台一把令牌)· 私有网在线状态 · 令牌轮换与吊销</p>
      </div>
      {/* 读失败就说读失败:绝不退回"暂无设备"——那两件事在台面上必须长得不一样 */}
      {error && <div className="mb-4"><LoadError error={error} onRetry={refetch} /></div>}
      {!error && (
        <div className="animate-fade-in-up" style={{ animationDelay: '0.08s' }}>
          <DeviceList terminals={terminals} onRegisterClick={() => setShowRegister(true)} onChanged={refetch} />
        </div>
      )}
      {showRegister && <RegisterDeviceModal onClose={() => setShowRegister(false)} onRegistered={refetch} />}
    </div>
  );
}
